import { produce } from 'immer'
import { AccountRevisionListResponse } from 'src/models/accountRevision.models'
import {
  GET_BUDGET_REVISIONS_SUCCESS,
  GetBudgetRevisionsSuccessAction,
} from 'src/redux/actions/data/budgetRevisions.actions'

export interface AccountRevisionsState {
  listResponses: Record<string, AccountRevisionListResponse>
}

export const initialState: AccountRevisionsState = {
  listResponses: {},
}

export type Actions = GetBudgetRevisionsSuccessAction

const AccountRevisionsReducer = (
  state: AccountRevisionsState = initialState,
  action: Actions,
): AccountRevisionsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_BUDGET_REVISIONS_SUCCESS: {
        draft.listResponses = action.payload.revisions.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.id]: curr,
          }),
          draft.listResponses,
        )
        return draft
      }
    }
  })
}

export default AccountRevisionsReducer
